import { IRole } from '../../types/user';

import { sortByOrder } from '../../lib/helpers';

import {
    IReview,
    IReviewRequest,
} from '../reviewHistoryPopup/reviewHistoryPopupTypes';

export const getIsCurrentRoleHasPermissionToEditReview = (
    reviewRequests: IReviewRequest[],
    reviews: IReview[],
    currentRole: IRole,
) => {
    const filteredReviews = reviews.filter((review) => review.type);
    const reviewsEmails = filteredReviews.length
        ? filteredReviews.map((review) => review.role.user.email)
        : [];
    const requests = (reviewRequests.length
        ? reviewRequests.filter((request) => {
              return !reviewsEmails.includes(request.toRole.user.email);
          })
        : []
    ).sort(sortByOrder);

    if (currentRole.isAdmin) {
        return true;
    }

    if (reviewRequests.some((req) => req.toRoleId === currentRole.id)) {
        return true;
    }

    if (reviewRequests.some((req) => req.fromRoleId === currentRole.id)) {
        return true;
    }

    if (!requests.length) {
        return true;
    }

    return false;
};

export const isRequestsHasCurrentRole = (
    requests: IReviewRequest[],
    currentRoleId: string,
) => {
    return requests.some((request) => {
        if (request.toGroupId) {
            return request.toGroup.members.some(
                (member) => member.role.id === currentRoleId,
            );
        }
        return request.toRoleId === currentRoleId;
    });
};
